import { computed, ComputedRef, Ref } from 'vue'

import { useConfig } from '@/composables/config'
import { useGetExternalUrl } from '@/composables/url-helpers'
import { useTr } from '@/composables/use-tr'
import { ROUTE_NAMES } from '@/router/constants'
import { APIGameType } from '@/types'

export function useShareData(game: Ref<APIGameType | undefined>): ComputedRef<ShareData> {
    const { VUE_APP_HOST_URL } = useConfig()
    const getExternalUrl = useGetExternalUrl()
    const tr = useTr()

    const shareData = computed(() => ({
        title: game.value?.title,
        text: tr('gameContainer.share_game_description', { title: game.value?.title ?? '' }),
        url:
            VUE_APP_HOST_URL +
            getExternalUrl({
                name: ROUTE_NAMES.GAME_PAGE,
                params: {
                    game: game.value?.hru,
                },
            }),
    }))

    return shareData
}
